import React from "react";
import { Message } from "components/generic/layout";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { colors } from "core/stylesheet";

const StyledLink = styled(Link)`
  color: ${colors.brand};
  text-decoration: none;
  font-weight: bold;
`;

export default ({ inviteLink }) => (
  <Message
    title="We have successfully received your feedback!"
    text="We hope to see you again soon!"
    showIcon
    subtext={
      <span>
        Give your friend $20 off on their first call by inviting them<StyledLink
          to={inviteLink}
        >
          {" "}
          here
        </StyledLink>
      </span>
    }
  />
);



// WEBPACK FOOTER //
// ./src/components/common/feedback/Success/index.js